(function () {
  var BLOCKED = [
    'IN','PK','BD','LK','IQ','TR','IR','SA','BH','EG','QA','SY','PH',
    'NG','UG','NE','DZ','MY','TN','ZW','ZM','ET','OM','SG'
  ];
  var KEY = 'triune_geo_v8';
  var TTL = 86400000;
  var DEBUG = /[?&]geo-debug=1\b/.test(location.search);

  // Shopify theme editor / admin preview, always bypass.
  // Detects: preview URL params, cross-origin iframe parent (admin loads
  // the storefront inside an iframe under *.shopify.com), or an
  // explicit ?geo-bypass=1 query flag for ad-hoc previews.
  function isShopifyPreview() {
    try {
      if (/[?&](preview_theme_id|_fd|_ab|pb)=/.test(location.search)) return true;
      if (/[?&]geo-bypass=1\b/.test(location.search)) return true;
      if (window.top !== window.self) {
        try {
          // Same-origin parent would not throw; cross-origin throws.
          var _ = window.top.location.href;
          return false;
        } catch (e) {
          // Cross-origin iframe, almost always the theme editor.
          return true;
        }
      }
    } catch (e) {}
    return false;
  }

  if (window.console) console.log('[geo] asset v8 loaded, debug=' + DEBUG + ', preview=' + isShopifyPreview());

  if (isShopifyPreview()) return;
  function log() {
    if (DEBUG && window.console) console.log.apply(console, ['[geo]'].concat([].slice.call(arguments)));
  }

  function blank() {
    try {
      document.documentElement.innerHTML = '<head></head><body></body>';
    } catch (e) {}
    try {
      window.stop && window.stop();
    } catch (e) {}
    try {
      window.location.replace('about:blank');
    } catch (e) {}
  }

  function hide() {
    var s = document.createElement('style');
    s.id = 'geo-gate';
    s.textContent = 'html{visibility:hidden!important}';
    (document.head || document.documentElement).appendChild(s);
  }
  function reveal() {
    var s = document.getElementById('geo-gate');
    if (s && s.parentNode) s.parentNode.removeChild(s);
  }

  function apply(country) {
    country = (country || '').toUpperCase();
    var blocked = country && BLOCKED.indexOf(country) !== -1;
    log('country=' + country + ' blocked=' + blocked);
    try {
      sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), b: blocked, c: country }));
    } catch (e) {}
    if (blocked) blank(); else reveal();
  }

  try {
    var raw = sessionStorage.getItem(KEY);
    if (raw) {
      var c = JSON.parse(raw);
      if (c && (Date.now() - c.t < TTL)) {
        log('cache hit', c);
        if (c.b) { blank(); return; }
        return;
      }
    }
  } catch (e) {}

  hide();

  fetch('https://api.country.is/', { cache: 'no-store' })
    .then(function (r) { if (!r.ok) throw new Error('primary ' + r.status); return r.json(); })
    .then(function (j) { return (j && j.country) || ''; })
    .catch(function (err) {
      log('primary failed:', err && err.message);
      return fetch('https://get.geojs.io/v1/ip/country.json', { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (j) { return (j && j.country) || ''; });
    })
    .then(apply)
    .catch(function (err) {
      log('all endpoints failed:', err && err.message);
      reveal();
    });
})();
